import { css } from '@emotion/css';
import { minScreen } from 'utils/mediaQueries';

export const h4 = css`
  margin: 0;
  font-size: 14px;
  line-height: 21px;
  ${minScreen('md')} {
    font-size: 16px;
    line-height: 24px;
  }
`;